import { FC } from 'react'
import StyledButton, { StyledButtonProps } from '@organs/StyledButton'
import ButtonStyle from '@enums/ButtonStyle'

type Props = Omit<StyledButtonProps, 'buttonStyle'>

const PrimaryButton: FC<Props> = (props) => (
  <StyledButton {...props} buttonStyle={ButtonStyle.PRIMARY} />
)

export default PrimaryButton
